<template>
    <FirstNavbarComponent />
    <PageHeader />
    <div class="page-content pt-0">
        <div class="content-wrapper">
            <div class="content">
                <CardComponent :title="$t('authLayout.projects')">
                    <div class="table-responsive">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>{{ $t('authLayout.name') }}</th>
                                    <th>{{ $t('authLayout.alias') }}</th>
                                    <th>{{ $t('authLayout.creationDate') }}</th>
                                    <th width="300px">{{ $t('authLayout.links') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="projectUser in projects">
                                <td>{{ projectUser.project.name }}</td>
                                <td>{{ projectUser.project.alias }}</td>
                                <td>{{ projectUser.project.createdAt }}</td>
                                <td>
                                    <a v-if="projectUser.approved_at" :href="generateUrl(`app/projects/${projectUser.project.uuid}/dashboard`, projectUser.project.alias)" class="btn btn-link legitRipple">{{ $t('buttons.navigate') }}</a>
                                    <template v-else>
                                        <button @click="approveInvitation(projectUser)" class="btn btn-success mr-2">{{ $t('buttons.approve') }}</button>
                                        <button @click="declineInvitation(projectUser)" class="btn btn-danger">{{ $t('buttons.decline') }}</button>
                                    </template>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="card-footer d-flex justify-content-between align-items-center">
                        <button type="button" @click="$refs.createProjectModal.show()" class="btn bg-indigo legitRipple float-right">Створити новий проект</button>
                    </div>
                </CardComponent>
            </div>
        </div>
    </div>
    <ModalComponent ref="createProjectModal" title="Створити новий проект">
        <form @submit.prevent="createProject">
            <div class="modal-body">
                <div class="form-group">
                    <label>{{ $t('authLayout.name') }}<span class="text-danger ml-1">*</span></label>
                    <input class="form-control" :placeholder="$t('authLayout.name')" v-model="project.name">
                </div>
                <div class="form-group">
                    <label>{{ $t('authLayout.alias') }}<span class="text-danger ml-1">*</span></label>
                    <input class="form-control" :placeholder="$t('authLayout.alias')" v-model="project.alias">
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn bg-indigo legitRipple float-right">{{ $t('buttons.create') }}</button>
            </div>
        </form>
    </ModalComponent>
</template>
<script>

import FirstNavbarComponent from "../../layouts/navbar/FirstNavBar/FirstNavBar.vue";
import PageHeader from "../../layouts/navbar/PageHeader.vue";
import {httpClient} from "../../../services/HttpClient";
import CardComponent from "../../../components/new/CardComponent.vue";
import ModalComponent from "../../../components/new/modal/AppModal.vue";
import {generateUrl} from "../../../utils";

export default            {
    name: "ProjectPickerPage",
    data() {
        return {
            projects : [],
            project: {
                name: "",
                alias: ""
            },
            processingStarted: false,
        }
    },
    components: {PageHeader, FirstNavbarComponent, CardComponent, ModalComponent},
    methods: {
        generateUrl,
        fetchProjects()
        {
            httpClient.get('/my/projects', {
                limit: 50
            }).then((response) => {
                this.projects = response.data.data
            }, this);
        },
        createProject()
        {
            httpClient.post('/registration/store-project', {
                name : this.project.name,
                alias : this.project.alias,
            }).then(() => {
                this.fetchProjects();

                this.$refs.createProjectModal.hide();
                this.project.name = '';
                this.project.alias = '';
            }, this);
        },
        approveInvitation(projectUser)
        {
            httpClient.post(`/projects/${projectUser.project.uuid}/users/${projectUser.uuid}/approve`).then(() => {
                this.fetchProjects();
            })
        },
        declineInvitation(projectUser)
        {
            httpClient.post(`/projects/${projectUser.project.uuid}/users/${projectUser.uuid}/decline`).then(() => {
                this.fetchProjects();
            })
        },
    },
    async mounted() {
        this.fetchProjects();
    }
}
</script>
